import React, { useState } from 'react';
import BatteryConfig from '../components/BatteryConfig';
import { Typography, Grid, Paper } from '@mui/material';
import { StyledButton, StyledTypography } from '../styles/styles';
import { useBatteryConfig } from "../context/BatteryConfigContext";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const BatterySoHAnalysis = () => {
    const { selectedConfig, setSelectedConfig } = useBatteryConfig();
    const [isConfig, setIsConfig] = useState(false);
    const navigate = useNavigate();
    const handleNavigateToSubmit = () => {
        navigate("/batteryscope/submit");
    };

    const handleNavigateToLifetimePlots = () => {
        navigate("/batteryscope/lifetime-analysis");
    };

    const diagnosticInsights = {
        Voltage_irregularities: "Detected voltage drops below threshold at multiple cycles.",
        Capacity_degradation: "Capacity has degraded by 10% over the last 100 cycles.",
        Resistance_increase: "Internal resistance has increased by 15%, indicating potential aging effects.",
        Predicted_failure_mode: "Potential short circuit due to increased impedance at high SoC levels.",
        Cycle_life_estimation: "Estimated remaining cycles: 1500.",
        Other_observations: "Minor discrepancies between digital twin model and actual data suggest calibration adjustments."
    };

    const thermalRunawayRisk = {
        Risk_level: "High",
        Temperature_threshold_exceedance: "Observed temperatures exceeded safe operating limits during high discharge cycles.",
        Thermal_hotspots: "Hotspots detected in Module 2, indicating uneven cooling or cell imbalance.",
        Safety_recommendations: "Reduce discharge rates or improve thermal management to mitigate risks.",
        Historical_incidents: "No previous thermal events recorded.",
        Monitoring_requirements: "Increase frequency of thermal monitoring during peak operations."
    };

    return (
        <div className="submit-battery-data mt-3 " style={{ maxHeight: "100%", overflowY: "auto" }}>
            {selectedConfig ? (
                <>
                    <StyledTypography variant="h6">
                        SoH Analysis
                    </StyledTypography>
                    <StyledButton
                        variant="contained"
                        onClick={handleNavigateToLifetimePlots}
                        className="gap-2"
                    >
                        Go to Lifetime Plots
                        <ArrowForwardIcon />
                    </StyledButton>

                    <BatteryConfig
                        voltage={selectedConfig.voltage}
                        capacity={selectedConfig.capacity}
                        cellType={selectedConfig.cellType}
                        cellCondition={"Recycled cell"}
                        ageYears={selectedConfig.ageYears}
                        ageMonths={selectedConfig.ageMonths}
                        chemistry={selectedConfig.chemistry}
                        format={selectedConfig.format}
                        makeModel={selectedConfig.makeModel}
                        isConfig={isConfig}
                        setIsConfig={setIsConfig}
                        setSelectedConfig={setSelectedConfig}
                        selectedConfig={selectedConfig}
                        sohData={true}
                        hideBox={true}
                    />
                    <Grid container spacing={3} className="mt-3 mb-20">
                        <Grid item xs={12} md={6}>
                            <Paper elevation={3} className="p-3 h-[330px] bg-[#333333]">
                                <StyledTypography variant="h6">Diagnostic Insights</StyledTypography>
                                <hr className="my-2" />
                                {Object.keys(diagnosticInsights).map((key, index) => (
                                    <StyledTypography key={index} variant="body1">
                                        <strong>{key.replace(/_/g, " ")}:</strong> {diagnosticInsights[key]}
                                    </StyledTypography>
                                ))}
                            </Paper>

                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper elevation={3} className="p-3 h-[330px] bg-[#333333]">
                                <StyledTypography variant="h6">Thermal Runaway Risk</StyledTypography>
                                {/* hr */}
                                <hr className="my-2" />
                                {Object.keys(thermalRunawayRisk).map((key, index) => (
                                    <StyledTypography key={index} variant="body1">
                                        <strong>{key.replace(/_/g, " ")}:</strong> {thermalRunawayRisk[key]}
                                    </StyledTypography>
                                ))}
                            </Paper>

                        </Grid>
                    </Grid>
                </>
            ) : (
                <>
                    <StyledTypography variant="h6" sx={{ color: "#e8442d" }}>
                        No Battery Data Selected
                    </StyledTypography>
                    <Typography variant="body1" gutterBottom className="mt-2 mb-4">
                        To visualize battery data, please submit your battery configuration first.
                    </Typography>
                    <StyledButton variant="contained" color="primary" onClick={handleNavigateToSubmit}>
                        Go to Submit Page
                    </StyledButton>
                </>
            )}
        </div>
    );
}

export default BatterySoHAnalysis;
